package org.hs_soft.runmynesto.data.api_datasource.options.export

import kotlinx.serialization.json.Json
import kotlinx.serialization.json.buildJsonObject
import kotlinx.serialization.json.put
import kotlinx.serialization.json.putJsonObject
import org.hs_soft.runmynesto.data.api_datasource.RequestManager
import org.hs_soft.runmynesto.domain.ApiClient
import org.hs_soft.runmynesto.domain.config.Errors
import org.hs_soft.runmynesto.domain.model.home.options.export.cash_reigster_gloabal_info.CashRegisterGlobalModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.export.CashReigsterGloabalRepository
import org.hs_soft.runmynesto.domain.util.ApiUtils

class CashRegisterGlobalRepositoryImpl(
    private val apiClient: ApiClient,
    private val requestManager: RequestManager,
) : CashReigsterGloabalRepository {

    override suspend fun getCashRegisterGlobal(): CashRegisterGlobalModel {
        val abortController = requestManager.createController()

        val graphQLQuery = buildJsonObject {
            put("query", """
                query getAppConfig {
                  ${ApiUtils.Field.cashAssist} {
                    ${ApiUtils.Field.getAppConfig} {
                      ...apaleo
                      ${ApiUtils.Field.__typename}
                    }
                    ${ApiUtils.Field.__typename}
                  }
                }
                
                fragment apaleo on AppConfig {
                  ${ApiUtils.Field.cashRegisterGlobal} {
                    ${ApiUtils.Field.apaleaoClientId}
                    ${ApiUtils.Field.apaleaoClientSecret}
                    ${ApiUtils.Field.__typename}
                  }
                  ${ApiUtils.Field.__typename}
                }
            """.trimIndent())
            
            // Empty variables as the query doesn't require any
            putJsonObject("variables") { }
        }

        val result = apiClient.requestResult(
            graphQLQuery = graphQLQuery,
            resource = ApiUtils.Cognito.API_URL,
            abortController = abortController,
        )

        return if (result != null) {
            Json.decodeFromString(result.decodeToString())
        } else {
            throw Exception(Errors.timeoutErr)
        }
    }
} 